import React, { useState } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import { Url } from 'src/api';
import useFetch from 'use-http';
import Checkbox from 'src/components/controls/forms/Checkbox';
import Owner from 'src/models/tract_detail/Owner';
import Ownership from 'src/models/tract_detail/Ownership';

interface IDeleteAdditionalOwnershipDialogProps {
    ownershipId: number;
    ownershipName: string;
    ownerships: Ownership[];
    owners: Owner[];
    onCloseDialog?: () => void;
    onComplete?: () => void;
}

const AORow: React.FC<{ ownership: Ownership; owner: Owner; checked: boolean; toggle: (id: number) => void }> = ({
    ownership,
    owner,
    checked,
    toggle,
}) => {
    return (
        <div>
            <Checkbox
                value={checked}
                onChange={() => toggle(ownership.id)}
                label={`${owner.name} (${owner.ownerType}) with ${ownership.decimalInterest} interest`}
            />
        </div>
    );
};

const DeleteAdditinalOwnershipDialog: React.FC<IDeleteAdditionalOwnershipDialogProps> = (props) => {
    const [checkedAdditionalOwnerships, setCheckedAdditionalOwnerships] = useState<number[]>([]);
    const [toggleAllChecked, setToggleAllChecked] = useState(false);
    const { post, response } = useFetch();
    const appContext = useSelector((storeState: IRootState) => storeState.appContext);

    const deleteORRI = async () => {
        const body = {
            additionalOwnershipList: checkedAdditionalOwnerships,
        };

        const url = `${Url.tract.horizon(appContext)}/ownerships/${props.ownershipId}/delete-additional-ownerships`;

        await post(url, body);

        if (response.ok) {
            console.log('repsonse ok');
            if (props.onCloseDialog) {
                console.log('calling on close dialog');
                props.onCloseDialog();
            }
            if (props.onComplete) {
                props.onComplete();
            }
        }
    };

    const toggle = (id: number) => {
        const list = [...checkedAdditionalOwnerships];
        if (_.includes(list, id)) {
            _.remove(list, (x) => x === id);
        } else {
            list.push(id);
        }

        setToggleAllChecked(list.length === props.ownerships.length);

        setCheckedAdditionalOwnerships(list);
    };

    const toggleAll = () => {
        if (checkedAdditionalOwnerships.length >= 0 && checkedAdditionalOwnerships.length < props.ownerships.length) {
            setCheckedAdditionalOwnerships(props.ownerships.map((o: Ownership) => o.id));
            setToggleAllChecked(true);
        } else {
            setCheckedAdditionalOwnerships([]);
            setToggleAllChecked(false);
        }
    };

    console.log(props.onCloseDialog);

    return (
        <Dialog title={`Delete Additional Ownership from ${props.ownershipName}`}>
            <Checkbox value={toggleAllChecked} onChange={toggleAll} label="Select/Deselect All Additiona Ownership" />
            <hr />
            {props.ownerships.map((os: Ownership) => {
                return (
                    <AORow
                        key={os.id}
                        ownership={os}
                        owner={props.owners.filter((o: Owner) => o.ownerLookUpId === os.ownerLookUpId)[0]}
                        checked={checkedAdditionalOwnerships.findIndex((i) => i === os.id) >= 0}
                        toggle={toggle}
                    />
                );
            })}
            <div style={{ textAlign: 'right', margin: '.7rem 0 .7rem 0' }}>
                <Button disabled={checkedAdditionalOwnerships.length <= 0} type="submit" text="Delete" intent="primary" onClick={deleteORRI} />
            </div>
        </Dialog>
    );
};

export default DeleteAdditinalOwnershipDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/dialogs/DeleteAdditionalOwnershipDialog.tsx